import { TOGGLE_THEME } from '@/store/mutation-types'

const state = {
  types: ['red', 'black'],
  active: 'red'
}

const mutations = {
  [TOGGLE_THEME] (state) {
    state.active = state.types.find(type => type !== state.active)
    const inactive = state.types.filter(type => type !== state.active)
    document.body.style.setProperty('--main', `var(--${ state.active })`)
    document.body.style.setProperty('--main-opposite', `var(--${ inactive })`)
  }
}

export default {
  state,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/theme.js